import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoiceCart = (props) => {

    const { cart, setCart, selectedCurrency, cartItem } = props;

    const { api, userData, settingData, accountData, rateFromToCurrency, selectedCompany,
        productData, refData, branchData, projectData, currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [spinning, setSpinning] = React.useState(false);
    const [scannedBarcode, setScannedBarcode] = useState("");



    // Account Options
    const accountOptions = accountData?.map(item => ({
        value: item.id,
        label: `${item.chartId}.${item.accountId} ${item.name}`,
        name: item.name,
    }));


    // Product Options
    const productOptions = productData?.map(item => ({
        value: item.id,
        label: `${item.sku ? ` (${item.sku}) ` : ''}  ${item.name} ${item.barcode ? ` [${item.barcode}]` : ''}`,
        id: item.id,
        categoryId: item.categoryId,
        productId: item.id,
        type: item.type,
        name: item.name,
        barcode: item.barcode,
        price: item.price,
        cost: item.cost,
        isStock: item.isStock,
        stock: item.totalStock,
        units: item.units,
        unit: item.unit,
        siAccountId: item.siAccountId,
        siVatAccountId: item.siVatAccountId,
        vat: item.vatGroup?.vat,
        currency: item.currency,
    }))

    const filterProducts = (inputValue, options) => {
        return options.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const loadProductOptions = (inputValue, callback) => {
        if (inputValue) {
            callback(filterProducts(inputValue, productOptions));
        } else {
            callback([]);
        }
    };



    // Add new row
    const handleAddRow = () => {
        setCart((prevCart) => [...prevCart, cartItem]);
    };

    // Delete VarientRow
    const handleDeleteRow = (event, type) => {
        event.preventDefault()

        if (cart.length > 1) {
            const updatedRows = cart.slice(0, -1);
            setCart(updatedRows);
        } else {
            toast.error('you need at least one item')
        }


    };

    // handle row changes
    const handleRowChange = (index, value, field) => {
        const updatedCart = [...cart];

        if (field == 'product') {
            updatedCart[index].productId = value.id;
            updatedCart[index].price = parseFloat(value.price);
            updatedCart[index].cost = rateFromToCurrency(value.currency, selectedCurrency, value.cost);
            updatedCart[index].units = value.units;
            updatedCart[index].unitQuantity = 1;
            updatedCart[index].quantity = 1;
            updatedCart[index].type = value.type;
            updatedCart[index].index = index;
            updatedCart[index].isStock = value.isStock;

            updatedCart[index].vatPercentage = value.vat;

            if (value.type == 'simple') {
                updatedCart[index].accountId = settingData.stockOfGoodsForSaleAccountId;
            }
            else if (value.type == 'rawMaterial') {
                updatedCart[index].accountId = settingData.stockOfRawMaterialsAccountId;
            }
            else if (value.type == 'production') {
                updatedCart[index].accountId = settingData.stockOfManufacturedProductsAccountId;
            }
        }
        else if (field == 'quantity') {
            updatedCart[index].quantity = value;

        }
        else if (field == 'unitQuantity') {
            updatedCart[index].unitQuantity = value;

        }
        else if (field == 'details') {
            updatedCart[index].details = value;

        }

        updatedCart[index].subQuantity = updatedCart[index].quantity * updatedCart[index].unitQuantity;
        updatedCart[index].netQuantity = parseFloat(updatedCart[index].subQuantity);

        updatedCart[index].priceDiscountAmount = (updatedCart[index].priceDiscountPercentage / 100) * (updatedCart[index].price * updatedCart[index].subQuantity);

        // TOTAL price
        updatedCart[index].netCost = (updatedCart[index].cost * updatedCart[index].subQuantity);

        setCart(updatedCart);
    }


    const handleBarcodeScan = (e) => {
        const barcode = e.target?.value;
        const product = productOptions?.find(option => option.barcode === barcode);

        if (!product) {
            toast.error('Product not found');
            return;
        }

        setCart((prevCart) => {
            let updatedCart = [...prevCart];
            const existingProductIndex = updatedCart.findIndex(option => option.productId === product.id);

            if (existingProductIndex > -1) {
                let quantity = updatedCart[existingProductIndex].quantity + parseFloat(1);
                handleRowChange(existingProductIndex, quantity, 'quantity');
            } else {
                // Add new product row

                let accountId;

                if (product.type == 'simple') {
                    accountId = settingData.stockOfGoodsForSaleAccountId;
                }
                else if (product.type == 'rawMaterial') {
                    accountId = settingData.stockOfRawMaterialsAccountId;
                }
                else if (product.type == 'production') {
                    accountId = settingData.stockOfManufacturedProductsAccountId;
                }

                const productItem = {
                    accountId: accountId,
                    productId: product.id,
                    price: parseFloat(product.price),
                    units: product.units,
                    type: product.type,
                    unitQuantity: 1,
                    subQuantity: 1,
                    priceDiscountAmount: 0,
                    priceDiscountPercentage: 0,
                    netQuantity: 1,
                    netPrice: product.price,
                    cost: product.cost,
                    quantity: 1,
                    vatPercentage: product.vat,
                };

                if (cart.length == 1 && !cart[0].productId) {
                    updatedCart = [productItem];
                } else {
                    updatedCart.push(productItem);
                }

            }

            return updatedCart;
        });

        setScannedBarcode('');
    };




    return (

        <div>

            <Spin spinning={spinning} fullscreen />


            <Row >
                <Col md={4}>
                    <Form.Label>Select Products</Form.Label>
                </Col>


                <Col>
                    <Form.Label>Unit</Form.Label>
                </Col>

                <Col>
                    <Form.Label>Cost</Form.Label>
                </Col>

                <Col>
                    <Form.Label>Quantity</Form.Label>
                </Col>

                <Col>
                    <Form.Label>net Quantity</Form.Label>
                </Col>
                <Col>
                    <Form.Label>Details</Form.Label>
                </Col>

            </Row>



            {cart.map((row, index) => (


                <Row className="g-0 mb-1" key={index}>
                    <Col md={4}>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={loadProductOptions}
                            defaultOptions={[]}
                            onChange={(e) => handleRowChange(index, e, 'product')}
                            value={productOptions?.find(option => option.value === cart[index].productId) || []}
                            noOptionsMessage={() => 'type to view'}
                            required
                        />
                    </Col>

                    {/* Units  Quantity*/}
                    <Col>
                        <Form.Select className="form-control form-control-sm" name='unitQuantity'
                            value={cart[index].unitQuantity}
                            onChange={(e) => handleRowChange(index, e.target.value, 'unitQuantity')}>
                            <option value={1}>{cart[index]?.unit} (x1)</option>
                            {cart[index]?.units?.map((unit, unitIndex) => (
                                <option key={index} value={unit.value}>{unit.unit} (x{unit.value})</option>
                            ))}

                        </Form.Select>
                    </Col>

                    {/* Cost */}
                    <Col>
                        <Form.Control type="number" min={0} step='any' value={cart[index].cost}
                            style={{ backgroundColor: '#f7e8e8' }}
                            disabled
                        />
                    </Col>

                    {/*  Quantity  */}
                    <Col>
                        <Form.Control type="number" min={0} step='any'
                            onChange={(e) => handleRowChange(index, e.target.value, 'quantity')}
                            style={{ backgroundColor: '#f0f8ff' }}
                            value={cart[index].quantity}
                            required
                        />
                    </Col>

                    {/* netQuantity */}
                    <Col>
                        <Form.Control type="number" min={0} step='any' value={cart[index].netQuantity}
                            style={{ backgroundColor: '#f7e8e8' }}
                            onChange={(e) => handleRowChange(index, e.target.value, 'netQuantity')}
                            disabled
                        />
                    </Col>

                    {/* Details */}
                    <Col>
                        <Form.Control as="textarea" rows={1}
                            value={cart[index].details}
                            onChange={(e) => handleRowChange(index, e.target.value, 'details')}
                        />
                    </Col>

                </Row>




            ))}





            <Row className="mb-3">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('cart')} />
                    <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'cart')} />

                </Col>

            </Row>

            <Row className="mb-3">

                <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <InputGroup style={{ backgroundColor: '#f0f8ff', width: '30%' }}>
                        <Form.Control type="text" placeholder='scan barcode to add ..'
                            value={scannedBarcode} onChange={e => setScannedBarcode(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') { handleBarcodeScan(e); } }} />
                        <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                    </InputGroup>
                </Col>
            </Row>

        </div>

    )
}


export default InvoiceCart;